const Form106EN = {
    stepName: {
        //importantNotes: "Important Notes",
        importantNotes: "Notes for Completing Parental Consent Form and Important Points",
        //applicationInformation: "Filing the Consent Form",
        applicationInformation: "Complete the Consent Form",
        confirmation: "Confirmation",
    },

    importantNotesContent: {
        title: "Points to Note for Filing the Form",
        start: "Please read the following notes to understand the purpose and relevant arrangements of the <b>Parental Consent Form</b> for the Transfer of Assessment Information of Pre-school Children.",
        //p1: "If your child <u><b>is not registered with any Child Assessment Centre (CAC) of the Department of Health or the Hospital Authority</b></u>, or if you have <u><b>decided to apply for admission to a special school for your child next school year according to the assessment and recommendation given by professionals</b></u>, you need not fill in and return this <b><u>Parental Consent Form.</b></u>",
        p1: "If your child <u><b>is not registered with a Child Assessment Centre (CAC)</u></b>, or if you have <u><b>decided to apply for admission to a special school for your child in the next school year in accordance with the assessment and recommendations of professionals</u></b>, you <u><b>do not need</u></b> to complete and return this <b>Parental Consent Form.</b>",
        p2: 'This electronic form <b><u>must be digitally signed using "iAM Smart+"</u></b>.',
        //p3: "Please read the following important information to understand the purpose of this form and related arrangements.",
        p3: "The Education Bureau (EDB) hereby seeks your consent to obtain your child’s assessment information from the respective CAC.  Subject to your consent, EDB will pass your duly signed <b>Parental Consent Form</b> to the relevant CAC, which will then provide your child’s assessment information in duplicate to EDB.  Following the release of the Primary One Central Allocation results, EDB will, as early as practicable, transfer one copy of the assessment information to the government, aided or Direct Subsidy Scheme primary school that your child will attend.  EDB will retain the other copy for reference.  The copy retained by EDB will be destroyed upon completion of the above information transfer exercise.  If necessary, we may contact you by phone to confirm the primary school that your child will attend.",
        termsConditions:
            "I have read, understood and agreed to the above important information, terms and conditions.",
    },

    GuidanceNotesContent: {
        title: "Guidance Notes",
        p2: "Your child is of the right age to attend Primary One in the next school year.  To enable the school to understand your child's needs and provide him/her with appropriate support, the Education Bureau (EDB) hereby seeks your consent for us to obtain your child's assessment information from the respective CAC.  Subject to your consent, EDB will pass your completed form to the relevant CAC.  The CAC will pass your child's assessment information (in duplicate) to EDB.  After the release of the central allocation results, the EDB will, as early as possible, transfer one copy of the assessment information to the government, aided, or Direct Subsidy Scheme (DSS) primary school that your child will attend, while the other will be kept by EDB for reference. The copy kept by EDB will be destroyed upon completion of the above-mentioned information transfer exercise. We will contact you by phone to confirm the primary school that your child will attend if necessary.",
        p3: "If the primary school could obtain your child’s assessment information before admission, it would help them plan and implement appropriate support services for your child earlier.  If there is any updated information (including follow-up assessment, other related training and follow-up by specialists, etc.) of your child after his/her entering primary school, parents can submit the respective information directly to the primary school for reference and appropriate follow-ups.",
        termsConditions:
            'I understand the applicant need to have an "iAM Smart+" account to process the application.',
    },

    applicationInformationContent: {
        label: {
            title1: "1.    Child's Information：",
            childNameZh: "Name of Child (Chinese)",
            noChineseName: "No Chinese Name",
            childNameEn: "Name of Child (English)",
            childGender: "Gender",
            childGenderOption: {
                male: "Male",
                female: "Female",
            },
            childBirthDate: "Date of Birth",
            childOtherIdentityDocumentNumber: "other identity document no.",
            childHkidOrOtherIdentityDocumentNumber: "Type of Identity Document",
            childHkidOrOtherIdentityDocumentNumberOption: {
                hkid: "Hong Kong Identity Card",
                otherIdNo: "Other Identity Document",
            },
            childHkidOrOtherIdentityDocumentNumberText: " No.",
            hkid: "Hong Kong Identity Card No.",
            otherIdNo: "Other Identity Document No.",
            childIdNumber: "Identity Document No",
            intendedPrimarySchoolName:
                "Please provide the following information if you have already registered your child for a government, aided, or Direct Subsidy Scheme primary school for the next academic year.  You may skip this part if the information is not currently available.  We will contact you by phone to confirm the primary school that your child will attend if necessary:",
            title2: "2.   Parent's / Guardian's Consent：",
            childEnrollNextYear1: "My child",
            childEnrollNextYear2:
                "study Primary One in the next school year and <u>is</u> registered with the Child Assessment Centre (CAC) below:",
            willNotOption: {
                yes: "will",
                no: "will not",
            },
            agreeNotOption: {
                yes: "give my consent",
                no: "do not give my consent",
            },
            district: "District",
            school: "School",
            trcArchiveNumber: "The file reference of my child in the CAC",
            nextStepAgreeEnrollNextYear1: "I hereby",
            nextStepAgreeEnrollNextYear2:
                "for the CAC indicated above to transfer my child's assessment information (if any) to EDB, and for EDB to transfer the said information to the government, aided or Direct Subsidy Scheme primary school that my child will attend.",
            nextStepNotAgreeEnrollNextYear1: "My child",
            nextStepNotAgreeEnrollNextYear2: "will not",
            nextStepNotAgreeEnrollNextYear3:
                "study Primary One in the next school year.  I hereby",
            nextStepNotAgreeEnrollNextYear4:
                "for EDB to contact me in due course to learn about the arrangement for assessment information transfer to primary school.",
            title3: "3.    Parent's / Guardian's Information:",
            guardianFullNameOption: {
                parent: "Parent's",
                legalGuardian: "Guardian's",
            },
            guardianFullNameOptionName: " Name",
            guardianFullName: "Name of Parent / Guardian",
            guardianIdentityDocumentNumber: "Identity Document No.",
            relationshipToChild: "Relationship with Child",
            contactNumber: "Contact Number",
            address: "Address",
            guardianSignDate: "Date",
            statementCheck: {
                label: "I declare that",
                label1: "I am the parent of the aforementioned child; and",
                label2: "I am the guardian of the aforementioned child; and",
                label3: "To the best of my knowledge and belief, the information contained in this form is true and correct.  If false information is provided, I understand that EDB may not be able to handle or further process the form.",
            },
        },

        errorMsg: {
            childNameZh: "Name of Child (Chinese)",
            childNameEn: "Name of Child (English)",
            childGender: "Gender",
            childBirthDate: "Date of Birth",
            childHkidOrOtherIdentityDocumentNumber: "Type of Identity Document",
            childIdNumber: "Identity Document No",
            guardianFullName: "Name of Parent / Guardian",
            guardianIdentityDocumentNumber: "Identity Document No.",
            relationshipToChild: "Relationship with Child",
            contactNumber: "Contact Number",
            address: "Address",
            guardianSignDate: "Date",
            numericOnly: "Numeric Only",
            cannotContainNumbers: "Cannot contain numbers",
        },
    },

    submittedDialog: {
        note1: "The application is submitted successfully.",
        note2: "Please submit the professional development portfolio (with action research project attached as an attachement) in duplicate together ",
        note3: "with this application form",
        note4: ":-",
        note5: "",
        note6: ":-",
        note7: "by hand to the Professional Development and Training Division, Education Bureau on 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong. (Please ring up the School Leadership and Professional Development Section on 3509 7471 at least 2 working days prior to the submission to facilitate the pre-registration for entry to the Central Government Offices); OR",
        note8: "by registered mail to the School Leadership and Professional Development Section, Professional Development and Training Division, Education Bureau, 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong.",
    },
    parameter: {
        centerSC: "Center Name (Simplified Chinese)",
        centerTC: "Center Name (Traditional Chinese)",
        centerEN: "Center Name (English)",
    },
};
export default Form106EN;
